import axios from 'axios';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async retriveAppEmailsNotification() {
      try {
        const permissions = await axios.get('/app-emails-notification', { withCredentials: true });
        return permissions.data;
      } catch (error) {
        throw error;
      }
    },
    async createAppEmailsNotification(context, data) {
      try {
        const config = { withCredentials: true };
        const response = await axios.post('/app-emails-notification', data, config);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    // async updateAppPermission(context, data) {
    //   try {
    //     const config = { withCredentials: true };
    //     const response = await axios.patch(`/app-permissions/${data.name}`, data.data, config);
    //     return response.data;
    //   } catch (error) {
    //     throw error;
    //   }
    // },
  },
};
